import { useEffect, useMemo } from 'react';
import { useGetCourtPageV2CoachReviewsLazyQuery } from 'types/generated/client';
import { useVenueCoaches } from '../VenueCoaches/useVenueCoaches';

/**
 * Reviews across every coach at the venue. Coach ids come from the same
 * useVenueCoaches queries the Coaches section fires (Apollo dedupes them).
 */
export const useVenueReviews = ({ venueId }: { venueId?: string }) => {
  const { coaches, isLoading: isCoachesLoading } = useVenueCoaches({ venueId });
  const [getReviews, { data, loading: isReviewsLoading, called: isReviewsCalled }] =
    useGetCourtPageV2CoachReviewsLazyQuery();

  const coachUserIds = useMemo(() => coaches.map((coach) => coach.id), [coaches]);
  const coachIdsKey = coachUserIds.join(',');

  useEffect(() => {
    if (!isCoachesLoading && coachUserIds.length > 0) {
      getReviews({ variables: { coachUserIds } });
    }
  }, [isCoachesLoading, coachIdsKey]);

  const reviews = data?.reviews || [];
  const isLoading =
    isCoachesLoading || (coachUserIds.length > 0 && (!isReviewsCalled || isReviewsLoading));

  return { reviews, isLoading };
};
